// Tiny pub/sub store for shop filter — shared between Hero search widget and Shop section
import { useEffect, useState } from "react";

const state = { size: "", season: "all" };
const listeners = new Set();

export function getShopFilter() {
  return state;
}

export function setShopFilter(patch) {
  Object.assign(state, patch);
  listeners.forEach((fn) => fn({ ...state }));
}

export function useShopFilter() {
  const [snap, setSnap] = useState({ ...state });
  useEffect(() => {
    const fn = (next) => setSnap(next);
    listeners.add(fn);
    return () => listeners.delete(fn);
  }, []);
  return snap;
}
